import gql from 'graphql-tag';

export const GET_GENERAL_GRAB_INFO = gql`
  {
    grabGetGeneralInfo
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/grab/fetchInfo.js